import { render, staticRenderFns } from "./Beneficiaries.vue?vue&type=template&id=1d741539&scoped=true"
import script from "./Beneficiaries.vue?vue&type=script&lang=js"
export * from "./Beneficiaries.vue?vue&type=script&lang=js"
import style0 from "./Beneficiaries.vue?vue&type=style&index=0&id=1d741539&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d741539",
  null
  
)

export default component.exports